import { getInvestmentTradeConfirmLink } from '@egw/api'
import { Logger } from '@egw/logger'
import { ArrowDownTrayIcon } from '@heroicons/react/24/solid'
import { useState, type FC } from 'react'

const log = new Logger('TradeLink')

export interface TradeLinkProps {
  alias: number
  fileKey: string
  title: string
  url?: string
}

export const TradeLink: FC<TradeLinkProps> = ({ alias, fileKey, title, url }) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleOpen = async (): Promise<void> => {
    setIsLoading(true)
    //  IF APEX TRADE CONFIRMATION URL WILL BE PROVIDED, OPEN IT DIRECTLY
    if (url) {
      setIsLoading(false)
      if (typeof window !== 'undefined') {
        window.open(url, '_blank')
      }
      return
    }

    // IF DRIVEWEALTH FILEKEY IS PROVIDED, FETCH THE URL AND OPEN IT
    try {
      const response = await getInvestmentTradeConfirmLink({ alias, fileKey })
      if (typeof window !== 'undefined') {
        window.open(response.confirm.url, '_blank')
      }
    } catch (error) {
      log.error('Error fetching trade confirmation link: ', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <button
      type="button"
      onClick={() => void handleOpen()}
      disabled={isLoading}
      className="text-base text-body flex w-full justify-between items-center text-body text-base font-normal border-light group w-full rounded-none border-b py-4 transition-all duration-200 cursor-pointer"
    >
      {title}
      <ArrowDownTrayIcon
        className="fill-blue-500 h-5 w-5 group-hover:fill-blue-700 flex-shrink-0"
        height={20}
        width={20}
      />
    </button>
  )
}
